import { ulid } from '../../shared/ulid';

const KEY = 'hsp_suggest_lock_token';

// A stable, per-browser cooperative token for the suggestion soft lock (Feature
// L). Persisted in localStorage so the same browser keeps its lock across a
// reload. Not a security secret — the lock is cooperative.
export function getOrCreateLockToken(): string {
  try {
    let token = localStorage.getItem(KEY);
    if (!token) {
      token = ulid();
      localStorage.setItem(KEY, token);
    }
    return token;
  } catch {
    // Private mode / storage blocked — a fresh session-only token still lets
    // this tab hold a lock; it just won't survive a reload.
    return ulid();
  }
}
